<template>
  <div class="page-agreement-license mpm-ptb20 mpm-plr32">
    <p>
      云e宝小白开单（以下简称
      “小白开单”）依据《云e宝小白开单服务协议》（以下简称“本协议”）的规定提供服务，本协议具有合同效力。注册用户时，请您认真阅读本协议，审阅并接受或不接受本协议（未成年人应在法定监护人陪同下审阅）。
      若您已经注册为本软件用户，即表示您已充分阅读、理解并同意自己与本软件订立本协议，且您自愿受本协议的条款约束。
      本软件有权随时变更本协议并在本软件上予以公告。经修订的条款一经在本软件公布后，立即自动生效。
      如您不同意相关变更，必须停止使用本软件。本协议内容包括协议正文及所有小白开单已经发布的各类规则。
      所有规则为本协议不可分割的一部分，与本协议正文具有同等法律效力。一旦您继续使用本软件，则表示您已接受并自愿遵守经修订后的条款。
    </p>
    <h2>一、用户资格</h2>
    <p>1、只有符合下列条件之一的自然人或法人才能申请成为本软件用户，可以使用本软件的服务：</p>
    <ul>
      <li>A、年满十八岁，并具有民事权利能力和民事行为能力的自然人；</li>
      <li>B、无民事行为能力人或限制民事行为能力人应经过其监护人的同意；</li>
      <li>
        C、根据中国法律、法规、行政规章成立并合法存在的机关、企事业单位、社团组织和其他组织。无法人资格的单位或组织不当注册为本软件用户的，其与本软件之间的协议自始无效，本软件一经发现，有权立即终止对该用户的服务，并追究其使用本软件服务的一切法律责任。
      </li>
    </ul>
    <p>2、用户需要提供明确的联系地址和联系电话，并提供真实姓名或名称。</p>
    <h2>二、用户的权利和义务</h2>
    <p>
      1、用户须自行负责自己的用户账号和密码，且须对在用户账号密码下发生的所有活动（包括但不限于设置信息、网上点击同意各类协议、规则等）承担责任。用户有权根据需要更改登录和账户密码。因用户的过错导致的任何损失由用户自行承担，该过错包括但不限于：遗忘或泄漏密码，密码被他人破解，您使用的计算机被他人侵入；
    </p>
    <p>
      2、用户应当向本软件提供真实准确的注册信息，包括但不限于真实姓名、联系电话、地址等。保证本软件可以通过上述联系方式与自己进行联系。同时，用户也应当在相关资料实际变更时及时更新有关注册资料；
    </p>
    <p>3、用户不得以任何形式擅自转让或授权他人使用自己在本软件的用户帐号；</p>
    <p>
      4、
      用户在本软件上设置的信息，不得违反国家法律、法规、行政规章的规定、不得侵犯他人知识产权或其他合法权益的信息、不得违背社会公共利益或公共道德、不得违反极认证的相关规定；
    </p>
    <p>
      5、用户承诺自己在使用本软件实施的所有行为遵守法律、法规、行政规章和本软件的相关规定以及各种社会公共利益或公共道德。如有违反导致任何法律后果的发生，用户将以自己的名义独立承担相应的法律责任；
    </p>
    <p>
      6、未经本软件书面允许，用户不得将本软件的任何资料以及在交易平台上所展示的任何信息作商业性利用（包括但不限于以复制、修改、翻译等形式制作衍生作品、分发或公开展示）；
    </p>
    <p>7、用户不得使用以下方式登录软件或破坏网站所提供的服务：</p>
    <ul>
      <li>A、以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它自动方式访问或登录本软件；</li>
      <li>B、通过任何方式对本公司内部结构造成或可能造成不合理或不合比例的重大负荷的行为；</li>
      <li>C、通过任何方式干扰或试图干扰软件的正常工作或软件上进行的任何活动。</li>
    </ul>
    <p>8、用户有权在同意本软件相关规则的前提下享受交易保障服务；</p>
    <p>9、用户同意接收来自本软件的信息，包括但不限于活动信息、增值信息、促销信息等。</p>
    <h2>三、小白开单的权利和义务</h2>
    <p>
      1、本软件有义务在现有技术水平的基础上努力确保整个软件的正常运行，尽力避免服务中断或将中断时间限制在最短时间内，保证用户使用软件操作的顺利进行；
    </p>
    <p>2、本软件有义务对用户在注册使用本网站信息平台中所遇到的问题及反映的情况及时作出回复；</p>
    <p>
      3、本软件有权对用户的注册资料进行审查，对存在任何问题或怀疑的注册资料，本软件有权发出通知询问用户并要求用户做出解释、改正；
    </p>
    <p>
      4、根据国家法律、法规、行政规章规定、本协议的内容和本软件所掌握的事实依据，可以认定该用户存在违法或违反本协议行为以及在本软件上的其他不当行为，本软件有权无需征得用户的同意以网络发布形式公布该用户的违法行为，并有权随时做出删除相关信息、终止服务提供等处理；
    </p>
    <h2>四、服务的中断和终止</h2>
    <p>
      1、本软件可自行全权决定以任何理由（包括但不限于本软件认为用户已违反本协议及相关规则的字面意义和精神等）终止对用户的服务，并有权在两年内保存用户在本软件的全部资料（包括但不限于用户信息、产品信息、交易信息等）。同时本网站可自行全权决定，在发出通知或不发
      出通知的情况下，随时停止提供全部或部分服务。服务终止后，本软件没有义务为用户保留原账户中或与之相关的任何信息；
    </p>
    <p>2、若用户申请终止本软件服务，需经本软件审核同意，方可解除与本软件的协议关系，但本网站仍保留下列权利：</p>
    <ul>
      <li>A、本网站有权在法律、法规、行政规章规定的时间内保留该用户的资料,包括但不限于以前的用户资料、交易记录等；</li>
      <li>B、若终止服务之前，该用户在本软件上存在违法行为或违反本协议的行为，本网站仍可行使本协议所规定的权利。</li>
    </ul>
    <p>3、用户存在下列情况，本软件可以终止向该用户提供服务：</p>
    <ul>
      <li>
        A、在用户违反本协议及相关规则规定时，本软件有权终止向该用户提供服务。本软件将在中断服务时通知用户。但该用户在被本软件终止提供服务后，再一次直接或间接或以他人名义注册为本软件用户的，本软件有权再次单方面终止为该用户提供服务；
      </li>
      <li>B、本协议终止或更新时，用户未确认新的协议的；</li>
      <li>C、其它本软件认为需终止服务的情况。</li>
    </ul>
    <h2>五、本网站的责任范围</h2>
    <p>当用户接受该协议时，用户应当明确了解并同意：</p>
    <p>
      1、本软件不能随时预见到任何技术上的问题或其他困难。该等困难可能会导致数据损失或其他服务中断。本软件是在现有技术基础上提供的服务。本软件不保证以下事项∶
    </p>
    <ul>
      <li>A、本软件将符合所有用户的要求；</li>
      <li>B、本软件不受干扰、能够及时提供、安全可靠或免于出错；</li>
      <li>C、本软件使用权的取得结果是正确或可靠的。</li>
    </ul>
    <p>2、 用户经由本软件取得的建议和资讯，无论其形式或表现，绝不构成本协议未明示规定的任何保证；</p>
    <p>
      3、基于以下原因而造成的利润、商誉、使用、资料损失或其它无形损失，本软件不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿（即使本软件已被告知前款赔偿的可能性）：
    </p>
    <ul>
      <li>A、本软件的使用或无法使用；</li>
      <li>B、用户的传输或资料遭到未获授权的存取或变更；</li>
      <li>C、本软件中任何第三方之声明或行为；</li>
      <li>D、本软件其它相关事宜。</li>
    </ul>
    <p>
      4、本软件只是为用户提供一个进销存记录的平台，对于用户所发布的信息的合法性、真实性及其品质，以及用户履行交易的能力等，本软件一律不负任何担保责任；
    </p>
    <p>
      5、本软件提供与其它互联网上的网站或资源的链接，用户可能会因此连结至其它运营商经营的网站，但不表示本软件与这些运营商有任何关系。其它运营商经营的软件均由各经营者自行负责，不属于本网站控制及负责范围之内。对于存在或来源于此类网站或资源的任何内容、广告、物品或其它资料，本软件亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类软件或资源获得的任何内容、物品或服务所产生的任何损害或损失，本软件不负任何直接或间接的责任。
    </p>
    <h2>六、知识产权</h2>
    <p>
      1、本软件及本软件所使用的任何相关软件、程序、内容，包括但不限于作品、图片、档案、资料、网站构架、网站版面的安排、网页设计、经由本软件或广告商向用户呈现的广告或资讯，均由本软件或其它权利人依法享有相应的知识产权，包括但不限于著作权、商标权、专利权或其它专属权利等，受到相关法律的保护。未经本软件或权利人明示授权，用户保证不修改、出租、出借、出售、散布本软件及本软件所使用的上述任何资料和资源，或根据上述资料和资源制作成任何种类产品；
    </p>
    <p>
      2、本网站授予用户不可转移及非专属的使用权，使用户可以通过单机计算机使用本软件的目标代码（以下简称"软件"），但用户不得且不得允许任何第三方复制、修改、创作衍生作品、进行还原工程、反向组译，或以其它方式破译或试图破译源代码，或出售、转让"软件"或对"软件"进行再授权，或以其它方式移转"软件"之任何权利。用户同意不以任何方式修改"软件"，或使用修改后的"软件"；
    </p>
    <p>3、用户不得经由非本软件所提供的界面使用本软件。</p>
    <h2>七、隐私权</h2>
    <p>1、信息使用：</p>
    <ul>
      <li>A、本软件不会向任何人出售或出借用户的个人或法人信息，除非事先得到用户得许可；</li>
      <li>
        B、本软件亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播用户的个人或法人信息。任何用户如从事上述活动，一经发现，本软件有权立即终止与该用户的服务协议，查封其账号。
      </li>
    </ul>
    <p>2、信息披露：用户的个人或法人信息将在下述情况下部分或全部被披露：</p>
    <ul>
      <li>A、经用户同意，向第三方披露；</li>
      <li>B、若用户是合法的知识产权使用权人并提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</li>
      <li>C、根据法律的有关规定，或者行政、司法机关的要求，向第三方或者行政、司法机关披露；</li>
      <li>D、若用户出现违反中国有关法律或者软件规定的情况，需要向第三方披露；</li>
      <li>E、为提供你所要求的产品和服务，而必须和第三方分享用户的个人或法人信息；</li>
      <li>F、其它本软件根据法律或者网站规定认为合适的披露。</li>
    </ul>
    <p>3、信息安全：</p>
    <ul>
      <li>A、在使用本软件服务进行网上交易时，请用户妥善保护自己的个人或法人信息，仅在必要的情形下向他人提供；</li>
      <li>
        B、如果用户发现自己的个人信息泄密，尤其是用户账户及密码发生泄露，请用户立即联络本软件客服，以便我们采取相应措施。
      </li>
    </ul>
    <h2>八、不可抗力</h2>
    <p>
      因不可抗力或者其他意外事件，使得本协议的履行不可能、不必要或者无意义的，双方均不承担责任。本合同所称之不可抗力意指不能预见、不能避免并不能克服的客观情况，包括但不限于战争、台风、水灾、火灾、雷击或地震、罢工、暴动、法定疾病、黑客攻击、网络病毒、电信部门技术管制、政府行为或任何其它自然或人为造成的灾难等客观情况。
    </p>
    <h2>九、保密</h2>
    <p>
      双方保证在对讨论、签订、执行本协议中所获悉的属于对方的且无法自公开渠道获得的文件及资料（包括但不限于商业秘密、公司计划、运营活动、财务信息、技术信息、经营信息及其他商业秘密）予以保密。未经该资料和文件的原提供方同意，另一方不得向第三方泄露该商业秘密的全部或者部分内容。但法律、法规、行政规章另有规定或者双方另有约定的除外。
    </p>
    <h2>十、争议解决方式</h2>
    <p>
      1、本协议及其规则的有效性、履行和与本协议及其规则效力有关的所有事宜，将受中华人民共和国法律管辖，任何争议仅适用中华人民共和国法律；
    </p>
    <p>
      2、凡因本协议及其规则发生的所有争议，争议双方可协商解决，若协商不成的，争议双方同意提交广州仲裁委员会按其仲裁规则进行仲裁。
    </p>
    <p>
      您对本协议理解和认同，您即对本协议所有组成部分的内容理解并认同，一旦您使用本服务，你和本公司即受本协议所有组成部分的约束。
    </p>
    <h2>十一、小白开单平台对本服务协议包括基于本服务协议制定的各项规则拥有最终解释权</h2>
  </div>
</template>

<script>
import APIBridge from '@/utils/api-bridge'
export default {
  created() {
    setTimeout(() => {
      APIBridge.hideLoading({
        title: '', // 非必填
        mask: true, // （有空实现），是否显示遮罩，阻止穿透点击
      })
    }, 100)
  },
}
</script>

<style lang="scss">
@media screen and (min-width: 700px) {
  html {
    font-size: 6.66667vw;
  }
}

.page-agreement-license {
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 28px;
    margin: 20px 0;
  }

  p {
    margin: 20px 0;
  }

  em {
    font-weight: bold;
  }

  ul {
    padding-left: 1em;
  }

  ul li {
    margin: 10px 0;
  }
}
</style>
